module.exports = __webpack_public_path__ + "static/windvane-547c1b382764ea4283acc48eddd27f0c.png";